// src/Redux/Dashboard/External/USER_PROFILE/UpdateTenantAction.js

import {
  PATCH_USER_TENANT_REQUEST,
  PATCH_USER_TENANT_SUCCESS,
  PATCH_USER_TENANT_FAILURE,
  PATCH_USER_TENANT_RESET,
} from '../../../Constants/actionTypes';

import { patchUserTenant } from '../../../Constants/apiService';

export const patchUserTenantRequest = () => ({ type: PATCH_USER_TENANT_REQUEST });
export const patchUserTenantSuccess = (data) => ({ type: PATCH_USER_TENANT_SUCCESS, payload: data });
export const patchUserTenantFailure = (error) => ({ type: PATCH_USER_TENANT_FAILURE, payload: error });
export const patchUserTenantReset = () => ({ type: PATCH_USER_TENANT_RESET });

export const updateTenantDetails = (payload) => {
  return async (dispatch, getState) => {
    dispatch(patchUserTenantRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const data = await patchUserTenant(payload, accessToken);
      dispatch(patchUserTenantSuccess(data));
      return data;
    } catch (err) {
      const message = err.message || 'Failed to update tenant details';
      dispatch(patchUserTenantFailure(message));
      throw err;
    }
  };
};
